export const RAFFLE_RESULTS_PAGE_SIZE = 10;
export const USER_TICKETS_PAGE_SIZE = 10;
